<template>
  <div>
    <disqualification-template ref="template" :orderStatus="43" type="destroy"/>
    <vxe-loading v-model="loading"/>
  </div>
</template>

<script>
import DisqualificationTemplate from '@/views/quality/disqualification/DisqualificationTemplate.vue'

export default {
  name: 'DisqualificationDestroyConfirm',
  components: { DisqualificationTemplate },
  data() {
    return {
      loading: false
    }
  },
  methods: {}
}
</script>